module.exports = __webpack_public_path__ + "static/img/img_review6.8165d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/img_review6.png
// module id = YJIZ
// module chunks = 0